import React, { memo, useEffect, useState, FC } from "react";
import classes from "./ClosableDrawerOfDepartment.module.scss";
import {
  Divider,
  Drawer,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
} from "@mui/material";
import { useRecoilState, useSetRecoilState } from "recoil";
import { setUserToLocalStorage } from "../../../functions/localStorageManager";
import { userState } from "../../../states/userState";
import { view } from "../../types/view";
import { User } from "../../types/user";
import { loadingState, loadingText } from "../../../states/loadingState";
import { useFetchProcesses } from "../../../hooks/useFetchProcesses";
import { kintoneArrayState } from "../../../states/kintonArrayState";
import { factories } from "../../../commons/factories";
import {
  isActiveFetchState,
  isOnlySearchState,
} from "../../../states/fetchState";
import { Filter } from "../../table/filter/Filter";
import { theme } from "../../../theme/theme";
import { useColumnsSetting } from "../../../hooks/useColumnsSetting";
import { getDefaultCheckedItems } from "../../../commons/productItems";
import {
  VIEW_ID_5253,
  VIEW_ID_54,
  VIEW_ID_ALL_FACTORY,
  VIEW_ID_PT,
  VIEW_ID_PV,
  VIEW_ID_SITE,
} from "../../../commons/views";
type Props = {
  viewsList: Array<view>;
  open: boolean;
  onClose: (
    event: React.MouseEvent<HTMLElement> | React.KeyboardEvent<HTMLElement>,
    isOpen: boolean
  ) => void;
  //   container: Element | null;
};

export const ClosableDrawer: FC<Props> = memo((props) => {
  const { viewsList, open, onClose } = props;
  const [users, setUsers] = useRecoilState<User>(userState);
  const [isExecuteAPI, setIsExecuteAPI] = useState<boolean>(false);
  const setLoadingAnimation = useSetRecoilState(loadingState);
  const setLoadingText = useSetRecoilState(loadingText);
  const setIsActiveFetch = useSetRecoilState(isActiveFetchState);
  const setIsOnlySearch = useSetRecoilState(isOnlySearchState);
  const { error, getProcessForFactory, getProcessForSite } =
    useFetchProcesses();
  const [kintone, setKintone] = useRecoilState(kintoneArrayState);
  const { createColumnsSetting } = useColumnsSetting();
  //console.log(departments);
  const onCloseHandler = (
    e: React.MouseEvent<HTMLElement> | React.KeyboardEvent<HTMLElement>
  ) => {
    onClose(e, false);
  };
  const selectMenu = (e: React.MouseEvent<HTMLElement>, viewId: number) => {
    //Recoilとローカルストレージに値を反映
    setUsers((prevState: User) => {
      const updatedUser = {
        ...prevState,
        viewId: viewId,
        filters: {
          ...prevState.filters,
          productItem: getDefaultCheckedItems(viewId),
        },
      };
      setUserToLocalStorage(updatedUser);
      return updatedUser;
    });
    setIsExecuteAPI(true);
    // console.log("isExecuteAPI", isExecuteAPI);
    onClose(e, false);
  };

  useEffect(() => {
    const fetchData = async (factoryids: number[]) => {
      // const areColumnsEmpty = (viewId: number) => {
      //   switch (viewId) {
      //     case VIEW_ID_ALL_FACTORY:
      //       return users.columnsAllFactory.length === 0;
      //     case VIEW_ID_PT:
      //       return users.columnsPT.length === 0;
      //     case VIEW_ID_PV:
      //       return users.columnsPV.length === 0;
      //     case VIEW_ID_54:
      //       return users.columnsKanto.length === 0;
      //     case VIEW_ID_5253:
      //       return users.columnsFukuokaKumamoto.length === 0;
      //     default:
      //       return users.columnsSite.length === 0;
      //   }
      // };
      // if (areColumnsEmpty(users.viewId)) {
      //   await makeHeader(factoryids, users.viewId);
      // }
      if (users.viewId !== VIEW_ID_SITE) {
        await fetchProcessForFactory(factoryids);
      } else {
        await fetchProcessForSite(factoryids);
      }
    };
    if (!users.isAuth) return;
    // console.log("isExecuteAPI", isExecuteAPI);
    if (!isExecuteAPI) return;

    // if (
    //   users.columnsAllFactory.length === 0 ||
    //   users.columnsPT.length === 0 ||
    //   users.columnsPV.length === 0 ||
    //   users.columnsKanto.length === 0 ||
    //   users.columnsFukuokaKumamoto.length === 0 ||
    //   users.columnsSite.length === 0
    // )
    //   return;
    let factoryids: number[] = [];
    switch (users.viewId) {
      case 0:

      case 9999:
        setUsers((prevState: User) => {
          const updatedUser = {
            ...prevState,
            filters: {
              ...prevState.filters,
              factory: [0],
              // salesNo: "",
              // productNo: "",
              // situation: [0],
              // office: [0],
              // field: [0],
            },
          };
          setUserToLocalStorage(updatedUser);
          return updatedUser;
        });
        factoryids = [0];
        break;
      case 50111:
        setUsers((prevState: User) => {
          const updatedUser = {
            ...prevState,
            filters: {
              ...prevState.filters,
              factory: [50, 55],
              // salesNo: "",
              // productNo: "",
              // situation: [0],
              // office: [0],
              // field: [0],
            },
          };
          setUserToLocalStorage(updatedUser);
          return updatedUser;
        });
        factoryids = [50, 55];
        break;
      case 50112:
        setUsers((prevState: User) => {
          const updatedUser = {
            ...prevState,
            filters: {
              ...prevState.filters,
              factory: [50],
              //salesNo: "",
              //productNo: "",
              //situation: [0],
              //office: [0],
              //field: [0],
            },
          };
          setUserToLocalStorage(updatedUser);
          return updatedUser;
        });
        factoryids = [50];
        break;
      case 54:
        setUsers((prevState: User) => {
          const updatedUser = {
            ...prevState,
            filters: {
              ...prevState.filters,
              factory: [54],
              //salesNo: "",
              //productNo: "",
              //situation: [0],
              //office: [0],
              //field: [0],
            },
          };
          setUserToLocalStorage(updatedUser);
          return updatedUser;
        });
        factoryids = [54];
        break;
      case 5253:
        setUsers((prevState: User) => {
          const updatedUser = {
            ...prevState,
            filters: {
              ...prevState.filters,
              factory: [52, 53],
              //salesNo: "",
              //productNo: "",
              //situation: [0],
              //office: [0],
              //field: [0],
            },
          };
          setUserToLocalStorage(updatedUser);
          return updatedUser;
        });
        factoryids = [52, 53];
        break;
      default:
    }
    // setKintone([]);
    fetchData(factoryids);
    setIsActiveFetch(true);
    setIsOnlySearch(false);
  }, [users.viewId, isExecuteAPI]);

  const fetchProcessForFactory = async (
    factoryids: Array<Number>,
    headerOnly: boolean = false
  ) => {
    // console.log("facrotyids", factoryids);
    const factoryIds = factoryids; //全件は0を指定する
    // const situations = [0]; //全件は0を指定する
    // const offices = [0]; //全件は0を指定する
    // const productNo = "";
    // const salesNo = "";
    // const field = [0];
    const situations = users.filters.situation; //全件は0を指定する
    const offices = users.filters.office; //全件は0を指定する
    const productNo = users.filters.productNo;
    const salesNo = users.filters.salesNo;
    const field = users.filters.field;
    const viewId = users.viewId;
    const productItems = users.filters.productItem;
    setLoadingAnimation(true);
    setLoadingText("データ取得中...");
    try {
      const response = await getProcessForFactory({
        factoryIds,
        situations,
        productNo,
        offices,
        salesNo,
        field,
        headerOnly,
        viewId,
        productItems,
      });
      // console.log(error);
      if (error) throw new Error(error);
      // console.log("responseFactory", response);
      setKintone(response);
      return response;
    } catch (e) {
      // setMessage("データ取得に失敗しました");
      // setIsShowErrorDialog(true);
    } finally {
      setLoadingAnimation(false);
      setLoadingText("");
      setIsExecuteAPI(false);
    }
  };
  const fetchProcessForSite = async (
    factoryids: Array<Number>,
    headerOnly: boolean = false
  ) => {
    // console.log("facrotyids", factoryids);
    const factoryIds = factoryids; //全件は0を指定する
    // const situations = [0]; //全件は0を指定する
    // const productNo = "";
    // const offices = [0];
    // const salesNo = "";
    // const field = [0];
    const situations = users.filters.situation; //全件は0を指定する
    const offices = users.filters.office; //全件は0を指定する
    const productNo = users.filters.productNo;
    const salesNo = users.filters.salesNo;
    const field = users.filters.field;
    const viewId = users.viewId;
    const productItems = users.filters.productItem;
    setLoadingAnimation(true);
    setLoadingText("データ取得中...");
    try {
      const response = await getProcessForSite({
        factoryIds,
        situations,
        productNo,
        salesNo,
        offices,
        field,
        headerOnly,
        viewId,
        productItems,
      });
      // console.log(error);
      if (error) throw new Error(error);
      setKintone(response);
      return response;
    } catch (e) {
      // setMessage("データ取得に失敗しました");
      // setIsShowErrorDialog(true);
    } finally {
      setLoadingAnimation(false);
      setLoadingText("");
    }
  };
  // const makeHeader = async (factoryIds: number[], viewId: number) => {
  //   //1件ずつフェッチ
  //   let result = [];
  //   if (viewId !== VIEW_ID_SITE) {
  //     result = await fetchProcessForFactory(factoryIds, true);
  //   } else {
  //     result = await fetchProcessForSite(factoryIds, true);
  //   }
  //   createColumnsSetting(result[0] || [], result || [], viewId);

  //   // console.log("result", result);
  //   // createColumnsSetting(result[0] || [], result || [], 9999);
  // };
  return (
    <nav className={classes.drawer} aria-label="mailbox folders">
      <Drawer
        // container={container}
        variant="temporary"
        anchor={"left"}
        open={open}
        onClose={onCloseHandler}
        classes={{
          paper: classes.drawerPaper,
        }}
        ModalProps={{
          keepMounted: true, // Better open performance on mobile.
        }}
      >
        <div
          //   onClose={(e) => onCloseHandler(e)}
          onKeyDown={(e) => onCloseHandler(e)}
          className={classes.drawerPaper}
        >
          <div className={classes.listRoot}>
            <h2
              className={classes.listTitle}
              style={color(users?.mode ?? "lite")}
            >
              Viewsets
            </h2>
            <Divider style={{ backgroundColor: "#777777" }} />
            {viewsList.map((view) => (
              <div
                key={view.id}
                className={classes.List}
                onClick={(e) => selectMenu(e, view.id)}
                // style={color(users?.mode ?? "lite")}
              >
                <img src={view.image} />
                <p style={color(users?.mode ?? "lite")}>{view.name}</p>
              </div>
            ))}
          </div>
        </div>
      </Drawer>
    </nav>
  );
});
const color = (mode: string) => {
  return {
    color:
      mode === "lite"
        ? theme.palette.darkColor.foreColor.main //間違いではない。色合いを考慮してdarkColorを指定している
        : theme.palette.darkColor.foreColor.main,
  };
};
